import { computed, inject, Signal } from '@angular/core';
import { TenantItemDto, UserDetailDto } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import TenantTypeEnum = UserDetailDto.TenantTypeEnum;

export function isInternalTenant(): Signal<boolean> {
  const adminService = inject(CurrentUserService);
  return computed(() => {
    return adminService.currentUser()?.tenantType === TenantTypeEnum.Internal;
  });
}

export function isExternalTenant(): Signal<boolean> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser()?.tenant.type === TenantTypeEnum.External);
}

export function isContractorTenant(): Signal<boolean> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser()?.tenantType === TenantTypeEnum.Contractor);
}

export function currentUser(): Signal<UserDetailDto | undefined | null> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser());
}

export function currentTenant(): Signal<TenantItemDto | undefined> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser()?.tenant);
}

export function currentTenantId(): Signal<string | undefined> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser()?.tenant.id);
}

// WR-2309: tenant whose catalog (Prüfpunkte, TGA-Typen, Aktionen, …) the current tenant uses —
// the own tenant unless a catalog source tenant is configured
export function catalogTenantId(): Signal<string | undefined> {
  const adminService = inject(CurrentUserService);
  return computed(() => {
    const tenant = adminService.currentUser()?.tenant;
    return tenant?.catalogSourceTenantId ?? tenant?.id;
  });
}

export function isCatalogReadOnly(): Signal<boolean> {
  const adminService = inject(CurrentUserService);
  return computed(() => !!adminService.currentUser()?.tenant.catalogSourceTenantId);
}

export function catalogSourceTenantName(): Signal<string | undefined> {
  const adminService = inject(CurrentUserService);
  return computed(() => adminService.currentUser()?.tenant.catalogSourceTenantName);
}

export function catalogReadOnlyBanner(): Signal<string | undefined> {
  const adminService = inject(CurrentUserService);
  return computed(() => {
    const sourceName = adminService.currentUser()?.tenant.catalogSourceTenantName;
    return sourceName ? `Katalog wird von ${sourceName} gepflegt — nur Lesezugriff.` : undefined;
  });
}
